export enum PendoEventType {
  CustomColumnCreated = 'Custom_column_created',
  CustomColumnEdited = 'Custom_column_edited',
  ContactMessageInbox = 'Contact_message_inbox',
  CorporateHistory = 'Corporate_history',
  SavedSearchPopoverOpened = 'saved_search_popover_opened',
  SavedSearchRun = 'saved_search_run',
  SavedSearchDelete = 'saved_search_delete',
  MarkAsReadClicked = 'mark_as_read_clicked',
  MarkAllAsReadClicked = 'mark_all_as_read_clicked',
  NewButtonHovered = 'new_button_hovered',
  SortDropdownClicked = 'Sort_dropdown_clicked',
  CustomListBulkAdd = 'Custom_list_bulk_add',
  CustomListCreatePopUp = 'Custom_list_create_pop_up',
  ShortlistEdit = 'Shortlist_edit',
  CustomListMoveOrCopy = 'Custom_list_move_or_copy',
  ShortlistProfileDelete = 'shortlist_profile_delete',
  ShortlistProfilesSearch = 'shortlist_profiles_search',
  SettingsClicked = 'Settings_clicked',
  LogoutClicked = 'Logout_clicked',
  ImportProspects = 'Import_prospects',
  AddToCustomList = 'Add_to_custom_list',
  SearchPageGrouping = 'Search_page_grouping',
}

export enum PendoContactMessageEvent {
  Move = 'Contact_message_inbox_move',
  Sort = 'Contact_message_inbox_sort',
  MenuClick = 'Contact_message_inbox_menu_click',
  Collapse = 'Contact_message_inbox_collapse',
  ChatClick = 'Contact_message_inbox_chat_click',
}

export enum PendoCorporateHistoryEventType {
  DefaultMeeting = 'Corporate_history_default_meeting',
  DateSelection = 'Corporate_history_date_selection',
}

export enum PendoSearchEventType {
  SearchIconTrigger = 'search_icon_trigger',
  PredictiveSearch = 'predictive_search',
  SearchEnterTrigger = 'search_enter_trigger',
  ClearSearchIcon = 'clear_search_icon',
}

export enum PendoCustomListBulkEventType {
  Add = 'add',
  Cancel = 'cancel',
  Tick = 'tick',
  Untick = 'untick',
  NewCancel = 'new_cancel',
  NewAdd = 'new_add',
}

export enum PendoCustomListFilterEventType {
  AddOne = 'sh_filter_add_one',
  UpdateOne = 'sh_filter_update_one',
  RemoveAll = 'sh_filter_remove_all',
  RemoveOne = 'sh_filter_remove_one',
  Close = 'sh_filter_close',
}

export enum PendoCustomListAddEventType {
  AddClick = 'add_click',
  CancelClick = 'cancel_click',
}

export enum PendoCustomListMoveOrCopyEventType {
  Move = 'move_profiles',
  MoveHandle = 'handle_move_profiles',
  Copy = 'copy_profiles',
  Cancel = 'cancel_click',
  NoProfilesClick = 'no_profiles_click',
}

export enum PendoImportProspectsEventType {
  EventSelected = 'event_selected',
  ParticipantSelected = 'participant_selected',
  FilterSelected = 'filter_selected',
  MainPopoverCancelClick = 'main_popover_cancel_click',
  MainPopoverImportClick = 'main_popover_import_click',
  MainPopoverSelectSpecificClick = 'main_select_specific_click',
  SelectSpecificSelectAllTickBoxClick = 'main_select_specific_select_all_click',
  SelectSpecificSelectTickBoxClick = 'main_select_specific_tick_box_click',
  SelectSpecificImportClick = 'main_select_specific_import_click',
}

export enum PendoAllProductsPageEventType {
  EventSelected = 'event_selected',
}
